module.exports = __webpack_public_path__ + "0c5da6120149f4484a75184c0f166637.svg";